import { toast } from "react-toastify";
import CustomTable from "../../../components/customTable/CustomTable";
import { IconButton, Tooltip } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { createMRTColumnHelper } from "material-react-table";
import ToastComponent from "../../../components/customTable/ToastComponent";

export default function SipTables({ sliceResponse ,stateLoading}) {
    const columnHelper = createMRTColumnHelper();
    const columns = [
        columnHelper.accessor("id", {
            header: "ID",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row?.original?.id);
                    toast.success("Copied to clipboard!");
                };
                return (
                    <Tooltip title={cell.row?.original?.id}>
                        <IconButton onClick={handleCopy}>
                            <ContentCopy />
                        </IconButton>
                    </Tooltip>
                );
            },
        }),
        columnHelper.accessor("clientName", {
            header: "Client Name",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original?.clientName}
                </div>
            ),
        }),
        columnHelper.accessor("partnerId", {
            header: "Partner ID",
            size: 30,
            Cell: ({ cell }) => {
                const handleCopy = () => {
                    navigator.clipboard.writeText(cell.row?.original?.partnerId);
                    toast.success("Copied to clipboard!");
                };
                return (
                    <Tooltip title={cell.row?.original?.partnerId}>
                        <>
                        <IconButton onClick={handleCopy}>
                            <ContentCopy />
                        </IconButton>
                        {cell.row?.original?.partnerId}
                        </>
                    </Tooltip>
                );
            },
        }),
        columnHelper.accessor("proposalNo", {
            header: "Proposal No",
            size: 30,
        }),
        columnHelper.accessor("orderType", {
            header: "Order Type",
            size: 30,
        }),
        columnHelper.accessor("metalType", {
            header: "Metal Type",
            size: 30,
        }),
        columnHelper.accessor("amount", {
            header: "Amount",
            size: 30,
        }),
        columnHelper.accessor("quantity", {
            header: "Quantity",
            size: 30,
        }),
        columnHelper.accessor("price", {
            header: "Price",
            size: 30,
        }),
        columnHelper.accessor("goldlivePrice", {
            header: "Gold Buy Price",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original?.goldlivePrice}
                </div>
            ),
        }),
        columnHelper.accessor("silverlivePrice", {
            header: "Silver Buy Price",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original?.silverlivePrice}
                </div>
            ),
        }),
        columnHelper.accessor("blockId", {
            header: "Block ID",
            size: 30,
        }),
        // columnHelper.accessor("status", {
        //     header: "Status",
        //     size: 30,
        // }),
        columnHelper.accessor("proposalType", {
            header: "Proposal Type",
            size: 30,
        }),
        columnHelper.accessor("dayOfMonth", {
            header: "Day of Month",
            size: 30,
        }),
        columnHelper.accessor("frequency", {
            header: "Frequency",
            size: 30,
        }),
        columnHelper.accessor("sipStatus", {
            header: "SIP Status",
            size: 30,
        }),
        columnHelper.accessor("subReferenceId", {
            header: "Sub Reference ID",
            size: 30,
        }),
        columnHelper.accessor("subscriptionId", {
            header: "Subscription ID",
            size: 30,
        }),
        columnHelper.accessor("isDeleted", {
            header: "Is Deleted",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original?.isDeleted ? "Yes" : "No"}
                </div>
            ),
        }),
        columnHelper.accessor("flag", {
            header: "Flag",
            size: 30,
        }),
        columnHelper.accessor("createdAt", {
            header: "Created At",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original.createdAt.split("T")[0]}
                </div>
            ),
        }),
        columnHelper.accessor("updatedAt", {
            header: "Updated At",
            size: 30,
            Cell: (cell) => (
                <div style={{ textAlign: "center" }}>
                    {cell.row.original.updatedAt.split("T")[0]}
                </div>
            ),
        }),
    ];
    return (
        <>
             {/*  */}

            <CustomTable columns={columns} data={sliceResponse}   
            loading={stateLoading} permissionKey="SIPMining"
            />

        </>
    )
}
